var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.19708 16.3848H0.879815V5.70248H4.19708V16.3848ZM2.53645 4.24534C1.47584 4.24534 0.615234 3.36648 0.615234 2.30591C0.615234 1.79639 0.817647 1.30774 1.17794 0.947455C1.53824 0.587171 2.02691 0.384766 2.53645 0.384766C3.04598 0.384766 3.53465 0.587171 3.89495 0.947455C4.25524 1.30774 4.45766 1.79639 4.45766 2.30591C4.45766 3.36648 3.59706 4.24534 2.53645 4.24534ZM16.6124 16.3848H13.3025V11.1848C13.3025 9.94534 13.2774 8.35619 11.5779 8.35619C9.85328 8.35619 9.5887 9.70248 9.5887 11.0956V16.3848H6.27487V5.70248H9.45612V7.15962H9.50241C9.94528 6.32019 11.027 5.43448 12.6408 5.43448C15.9981 5.43448 16.6152 7.64534 16.6152 10.5168V16.3848H16.6124Z",
    fill: "#FBFBFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin-icon.ce9e85c47c65e4090abf653ce65680aa.svg";
export { ForwardRef as ReactComponent };